module.exports = __webpack_public_path__ + "static/media/queens.78f8ee55.webp";